import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=7e9519be&"
import script from "@/scripts/adminManager/systemSettings.js?vue&type=script&lang=js&"
export * from "@/scripts/adminManager/systemSettings.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports